<template>
  <Popover
    v-slot="{ open }: { open: boolean }"
    as="div"
  >
    <PopoverButton
      class="flex justify-between w-full text-sm font-semibold capitalize"
      data-test-id="category-list-trigger"
    >
      <span>Filters</span>

      <SvgIcon
        aria-hidden="true"
        icon-name="chevron-down"
        class="w-5 h-4 shrink-0"
        :class="{
          'rotate-180': open,
        }"
      />
    </PopoverButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-out"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <PopoverPanel
        class="mt-5"
        :unmount="false"
      >
        <slot />
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script lang="ts">
export default { name: 'FilterAccordion' }
</script>

<script setup lang="ts">
import {
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@headlessui/vue'

import SvgIcon from '../../global/SvgIcon.vue'
</script>
